import type { ReactElement } from 'react';
import { Link } from 'react-router';
import { buttonVariants, cn } from '@/shared/ui';
import type { HeroSlideCopy } from './hero-slide-item';

interface HeroCopyProps {
  readonly copy: HeroSlideCopy;
}

const CTA_CLASS = cn(buttonVariants({ size: 'lg' }), 'mt-3 self-start');

/**
 * 히어로 왼쪽 문구 — 작은 라벨·큰 문구·보조 문구와 버튼. 비운 줄은 그리지 않는다.
 * 사진 위든 흑연 판 위든 흰 글자다(위에 얹은 흰 로고·메뉴와 같은 색).
 * 버튼 링크가 사이트 안 경로면 앱 안에서 이동하고, https 주소면 같은 탭의 일반 링크로 연다.
 */
export const HeroCopy = ({ copy }: HeroCopyProps): ReactElement => (
  <div className="flex max-w-xl flex-col gap-3 text-white">
    {copy.eyebrow !== null ? (
      <p className="text-sm font-medium sm:text-base">{copy.eyebrow}</p>
    ) : null}
    {copy.title !== null ? (
      <h2 className="text-[clamp(2rem,4.2vw,3.5rem)] leading-[1.15] font-bold tracking-[-0.02em] break-keep">
        {copy.title}
      </h2>
    ) : null}
    {copy.subtitle !== null ? (
      <p className="text-sm text-white/85 tabular-nums break-keep sm:text-lg">{copy.subtitle}</p>
    ) : null}
    {copy.cta === null ? null : copy.cta.href.startsWith('/') ? (
      <Link to={copy.cta.href} className={CTA_CLASS}>
        {copy.cta.label}
      </Link>
    ) : (
      <a href={copy.cta.href} className={CTA_CLASS}>
        {copy.cta.label}
      </a>
    )}
  </div>
);
